/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PurchaseCaseFileType } from './purchaseCaseFileType.model';


export interface PurchaseCaseFileDto { 
    dataSize?: number;
    id?: number;
    name?: string;
    purchaseCaseFileType: PurchaseCaseFileType;
    type?: string;
    updated?: string;
}
export namespace PurchaseCaseFileDto {
}


